import { ProductGroup } from "../@types";
import { productGroupsActions } from "../action-types";

export const setModalProductGroups = (
  val: boolean
): productGroupsActions.IProductGroupsModalState => ({
  type: productGroupsActions.PRODUCT_GROUPS_MODAL_STATE,
  payload: val,
});

export const setProductGroupForUpdate = (
  val: ProductGroup | undefined
): productGroupsActions.IGetProductGroupForUpdate => ({
  type: productGroupsActions.GET_PRODUCT_GROUP_FOR_UPDATE,
  payload: val,
});

export const setIsUpdateProductGroup = (
  val: boolean
): productGroupsActions.IIsProductGroupForUpdate => ({
  type: productGroupsActions.IS_PRODUCT_GROUP_FOR_UPDATE,
  payload: val,
});

export const refreshTableProductGroups = (
  val: boolean
): productGroupsActions.ISwitchProductGroupsRefreshTable => ({
  type: productGroupsActions.SWITCH_PRODUCT_GROUPS_REFRESH_TABLE,
  payload: val,
});
